import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { payer, payerData } from '../../../interfaces/patient-services/payer';
import { payerApi } from '../api/payer.api';

@Injectable() 
export class payerService extends payerData{
 
  constructor(private api: payerApi) {
    super();
  } 
  
  getall(url: string): Observable<payer[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<payer>{
      return this.api.getby_id(url);
  }

  create(url: string, data:payer): Observable<payer[]> {
    return this.api.add(url,data);
  }

  getData(url: string, data:any): Observable<any[]> {
    return this.api.getData(url,data);
  }

  update(url: string, data:payer): Observable<payer> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
